"use client";

import { createContext } from "react";

export type ParentHoverContextState = {
  parentHover: boolean;
};

export const ParentHoverContext = createContext<
  ParentHoverContextState | undefined
>(undefined);
